import { render, staticRenderFns } from "./VgtPagination.vue?vue&type=template&id=323d3da0&"
import script from "./VgtPagination.vue?vue&type=script&lang=js&"
export * from "./VgtPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\Users\\860552\\Downloads\\work\\kronex-home.by\\bitrix\\templates\\b2bportal_kr\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('323d3da0', component.options)
    } else {
      api.reload('323d3da0', component.options)
    }
    module.hot.accept("./VgtPagination.vue?vue&type=template&id=323d3da0&", function () {
      api.rerender('323d3da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/vgt/VgtPagination.vue"
export default component.exports